module.exports = __webpack_public_path__ + "img/avenue_logo.f92f5e6c.png";